// Lazy-load background videos ([data-lazy-video]) so they don't affect initial
// page load: the source is only fetched/played once the video nears the viewport.
const lazyVideos = document.querySelectorAll('[data-lazy-video]');

if (lazyVideos.length) {
  // Phones get the lighter portrait file when a data-src-mobile is provided.
  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  const load = (video) => {
    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.src) {
        source.src = (isMobile && source.dataset.srcMobile) || source.dataset.src;
      }
    });
    video.muted = true; // required for autoplay
    video.load();
    video.play().catch(() => {});
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          load(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { rootMargin: '200px' }
    );
    lazyVideos.forEach((v) => io.observe(v));
  } else {
    lazyVideos.forEach(load); // no IO support: just load them
  }
}
